var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.436,
    height: 121.698,
    viewBox: "0 0 86.436 121.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "follower-icon",
    transform: "translate(-747.244 -283.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13850",
    "data-name": "Group 13850",
    transform: "translate(747.749 277.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-688.185,9263.581h-7.871c-.159-.007-.322-.02-.5-.039a8.612,8.612,0,0,1-5.82-3.188,8.613,8.613,0,0,1-1.86-6.371,21.819,21.819,0,0,1,3.923-12.395,33.52,33.52,0,0,1,9.857-9.269,50.873,50.873,0,0,1,12.923-5.809,47.412,47.412,0,0,1,13.122-2.011h5.332a48.642,48.642,0,0,1,13.331,2.011,51.166,51.166,0,0,1,13.03,5.809,33.473,33.473,0,0,1,9.9,9.269,21.793,21.793,0,0,1,3.933,12.395v.356c.009.11.016.225.021.338a8.5,8.5,0,0,1-2.255,6.15,8.5,8.5,0,0,1-5.943,2.754h-7.885a26.454,26.454,0,0,0-2.092-10.361,26.538,26.538,0,0,0-5.7-8.461,26.542,26.542,0,0,0-8.461-5.705,26.464,26.464,0,0,0-10.361-2.092,26.467,26.467,0,0,0-10.362,2.092,26.54,26.54,0,0,0-8.461,5.705,26.538,26.538,0,0,0-5.7,8.461,26.459,26.459,0,0,0-2.092,10.361Z",
    transform: "translate(704.285 -9157.399)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M792.279,337.168a20.135,20.135,0,0,0,15.287-6.4,45.251,45.251,0,0,0,9.6-29.16,24.895,24.895,0,0,0-49.781,0,46.552,46.552,0,0,0,9.6,29.481A21.19,21.19,0,0,0,792.279,337.168Z",
    transform: "translate(-749.558 -270.075)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_706",
    "data-name": "Ellipse 706",
    cx: 21.619,
    cy: 21.619,
    r: 21.619,
    transform: "translate(768.849 361.739)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11258",
    "data-name": "Path 11258",
    d: "M802.352,394.968l-8.757,8.756a2.839,2.839,0,0,1-4.014,0h0a2.839,2.839,0,0,1,0-4.014l6.75-6.749-6.75-6.75a2.839,2.839,0,0,1,0-4.014h0a2.839,2.839,0,0,1,4.014,0l8.757,8.757A2.839,2.839,0,0,1,802.352,394.968Z",
    transform: "translate(-3.779 -9.603)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowerIcon);
export default __webpack_public_path__ + "static/media/follower-icon.6fdd5b7f4c62b2382a5fa4dc4ca74b68.svg";
export { ForwardRef as ReactComponent };